import React from "react";
import SettingsPage from "./SettingsPage";
import AddCustomShop from "./AddCustomShop";

interface ModalsProps {
  showSettings: boolean;
  setShowSettings: (show: boolean) => void;
  isDarkMode: boolean;
  toggleTheme: () => void;
  isTrackingLocation: boolean;
  toggleLocationTracking: () => void;
  defaultMapType: string;
  setDefaultMapType: (type: string) => void;
  userPreferences: any;
  userLocation: [number, number] | null;
  onShopCreated: (apiResponse: any) => void;
  isUserMenuOpen: boolean;
  showFilters: boolean;
}

const Modals: React.FC<ModalsProps> = ({
  showSettings,
  setShowSettings,
  isDarkMode,
  toggleTheme,
  isTrackingLocation,
  toggleLocationTracking,
  defaultMapType,
  setDefaultMapType,
  userPreferences,
  userLocation,
  onShopCreated,
  isUserMenuOpen,
  showFilters,
}) => (
  <>
    {/* Add Custom Shop */}
    <AddCustomShop userLocation={userLocation} onShopCreated={onShopCreated} isDarkMode={isDarkMode} hideButton={isUserMenuOpen} showFilters={showFilters} />

    {/* Settings Page */}
    <SettingsPage
      isOpen={showSettings}
      onClose={() => setShowSettings(false)}
      isDarkMode={isDarkMode}
      onToggleTheme={toggleTheme}
      isTrackingLocation={isTrackingLocation}
      onToggleLocationTracking={toggleLocationTracking}
      defaultMapType={defaultMapType}
      onMapTypeChange={(mapType) => {
        setDefaultMapType(mapType);
        userPreferences.setDefaultMapType(mapType);
      }}
      showFilters={showFilters}
    />
  </>
);

export default Modals;
